export default __webpack_public_path__ + "static/media/RotacionaKomoraGrejac.0588ddb3.png";